
export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative h-screen min-h-[900px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/ec3e95630dcf1be4e404d11b5ac6f799.png"
          alt="Large inventory of 48x40 4-way 3-stringer standard pallets"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="lg:w-2/5 text-white mb-12 lg:mb-0">
            <div className="flex items-center space-x-3 mb-8">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm border-2 border-white flex items-center justify-center">
                  <i className="ri-building-line text-white text-sm"></i>
                </div>
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm border-2 border-white flex items-center justify-center">
                  <i className="ri-store-line text-white text-sm"></i>
                </div>
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm border-2 border-white flex items-center justify-center">
                  <i className="ri-truck-line text-white text-sm"></i>
                </div>
              </div>
              <span className="text-sm font-medium">Trusted by 150+ Businesses Nationwide</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Premium Pallets<br />Delivered Nationwide
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto">
              Buy 48x40 Pallets, Custom Pallets, Standard Pallets & GMA Pallets - Quality Solutions for Your Business
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => scrollToSection('catalog')}
                className="bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                View Products
              </button>
              <button
                onClick={() => scrollToSection('quotation')}
                className="bg-white text-orange-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </button>
            </div>
          </div>

          <div className="lg:w-2/5 text-white text-right">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <p className="text-2xl font-semibold mb-4">Standard, Custom & GMA Pallets</p>
              <p className="text-lg mb-2">Same-Day Quotes | Nationwide Delivery</p>
              <p className="text-lg">48×40 Specialists Since 2021</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
